//imports
import {
    GENERAL_AUDIT_LOGS_OPEN_MODAL,
    GENERAL_AUDIT_LOGS_SEARCH_REQUEST,
    GENERAL_AUDIT_LOGS_SEARCH_RESULT,
    GENERAL_AUDIT_LOGS_SEARCH_MODULES_REQUEST,
    GENERAL_AUDIT_LOGS_SEARCH_MODULES_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    change: null,
    openModal: false,
    loading: false,
    entityName: null,
    entityId: null,
    companyId: null,
    auditlogId: null,
    date: null,
    changes: null,
    action: null,
    method: null,
    modules: [],
    modulesLoading: false,
}

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case GENERAL_AUDIT_LOGS_OPEN_MODAL:
            return {
                ...state,
                openModal: action.payload.open,
                entityName: action.payload.entityName,
                entityId: action.payload.entityId,
                companyId: action.payload.companyId,
                auditlogId: action.payload.id,
                date: action.payload.date,
                changes: action.payload.changes,
                action: action.payload.action,
                method: action.payload.method,
            }

        case GENERAL_AUDIT_LOGS_SEARCH_REQUEST:
            return { ...state, loading: true }

        case GENERAL_AUDIT_LOGS_SEARCH_RESULT:
            return { ...state, loading: false, change: action.payload.result }

        case GENERAL_AUDIT_LOGS_SEARCH_MODULES_REQUEST:
            return { ...state, modulesLoading: true }

        case GENERAL_AUDIT_LOGS_SEARCH_MODULES_RESULT:
            return { ...state, modulesLoading: false, modules: action.payload }

        case CLEAR_REDUX:
            return ["", "GENERAL_AUDIT_LOGS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};